// extracted by mini-css-extract-plugin
module.exports = {"power-preparedness-G":"G_power-preparedness-G__OOGBF"};